// extracted by mini-css-extract-plugin
export var option = "_bv-0";
export var optionCard = "_bv-f";
export var optionContent = "_bv-g";
export var optionIcon = "_bv-i";
export var optionIconBox = "_bv-h";
export var optionLabel = "_bv-j";
export var optionPill = "_bv-m";
export var optionPillBadge = "_bv-p";
export var optionPillIcon = "_bv-n";
export var optionPillLabel = "_bv-o";
export var optionRadio = "_bv-k";
export var optionRadioInner = "_bv-l";
export var optionReveal = "_bv-2";
export var optionRevealDelay0 = "_bv-3";
export var optionRevealDelay1 = "_bv-4";
export var optionRevealDelay10 = "_bv-d";
export var optionRevealDelay11 = "_bv-e";
export var optionRevealDelay2 = "_bv-5";
export var optionRevealDelay3 = "_bv-6";
export var optionRevealDelay4 = "_bv-7";
export var optionRevealDelay5 = "_bv-8";
export var optionRevealDelay6 = "_bv-9";
export var optionRevealDelay7 = "_bv-a";
export var optionRevealDelay8 = "_bv-b";
export var optionRevealDelay9 = "_bv-c";
export var optionSelected = "_bv-1";